import cn from 'clsx'

// Components
import { Link, Tooltip, IconShare } from '@tracklib/kit'

import styles from './sharebutton.css'

type ShareButtonProps = {
  url?: string
  children?: JSX.Element
  isLoop?: boolean
  className?: string
}

const ShareButton = ({ url = window.location.href, children, isLoop, className }: ShareButtonProps): JSX.Element => {
  const title = `Share ${isLoop ? 'loop' : 'track'}`
  return (
    <div data-tooltip-wrapper>
      <Tooltip>{title}</Tooltip>
      <Link
        to="share"
        modal
        query={{ url }}
        className={cn(styles.button, className)}
        datatesting="share_button"
        title={title}
        ariaLabel={title}
      >
        <IconShare className={styles.icon} />
        {children}
      </Link>
    </div>
  )
}

export default ShareButton
